import { PartialPageSlugSchema } from '@/components/cms/schemas';
import { Link, useLocation } from '@tanstack/react-router';
import parse, { Element } from 'html-react-parser';
export function ReplaceHtmlWithReact({ value }: { value: string }) {
  const location = useLocation();

  return parse(value, {
    replace(domNode) {
      if (!(domNode instanceof Element)) {
        return domNode;
      }

      if (domNode.name !== 'a') {
        return domNode;
      }

      if (!domNode.attribs.href) {
        return domNode;
      }

      const replacedTag = domNode.attribs.href.replace('#', '');

      // TODO: Add more drawer here, for example: (Esim compatibility)
      if (replacedTag !== 'drawer-international-calling') {
        return domNode;
      }

      if (!domNode.firstChild) {
        return domNode;
      }

      return (
        <Link
          to={location.pathname}
          search={(prev) => ({
            ...prev,
            drawer: PartialPageSlugSchema.Enum['unlimited-international'],
          })}
        >
          {/* @ts-expect-error type data is null but when we log domNode.firstChild.data, it does exist. not sure why react parser expects this data as not part of the field. We have to get the data to have the text inside of an element <a> data here </a>*/}
          {domNode.firstChild.data}
        </Link>
      );
    },
  });
}
